<div class="comparative-analysis-page">
  <div class="top-action-section">
    <div class="filter-container">
      <div class="filter">
        <label class="filter-label">Tickers</label>
        <div class="ticker-search-filter">
          <app-ticker-search
            [tickers]="tickers"
            [onScreen]="true"
            [isComp]="true"
            [hasSearchIcon]="true"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            [suggestedTickers]="suggestedPeers"
            placeholder="&nbsp;Add Tickers"
            [maxSelectedTickerCount]="tickerLimit"
            (onSearchedTickerUpdate)="onSearchTickerSelection($event)"
          ></app-ticker-search>

          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="editTickers()"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
          >
            Edit
          </button>
        </div>
      </div>
      <div class="filter">
        <app-lineitem-filter
          [options]="lineItemsData"
          [selectedValue]="
            lineItem
              ? { value: lineItem.uniquesliid, label: lineItem.name }
              : {}
          "
          [selectedOptionsId]="selectedLineItemId"
          liFilterId="comparative{{ pageShortName }}LI"
          [bottomBorderView]="true"
          [disabled]="
            isMetaInProgress ||
            isStdLineItemsUpdateInProgress ||
            isUserSettingUpdateInProgress
          "
          placeholder="&nbsp;Add Line Item"
          [showLabel]="true"
          label="Line Items"
          [showButton]="false"
          (onValueChange)="handleLineItemSelection($event)"
        ></app-lineitem-filter>
      </div>
      <div class="filter comparative-currency-filter">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="currency"
          [disabled]="
            isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
          "
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="handleCurrencyChange($event)"
        >
        </va-currency-select>
      </div>
    </div>
    <div class="cta-right-section">
      <!-- export button -->
      <button
        class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
        [ngClass]="[
          exportOptVisible ? 'va-button--active' : '',
          isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
            ? 'va-button--disabled'
            : ''
        ]"
        nz-popover
        nzPopoverTrigger="click"
        [nzPopoverContent]="exportOptionsTemplate"
        [(nzPopoverVisible)]="exportOptVisible"
        [nzPopoverPlacement]="'bottomRight'"
        [nzPopoverOverlayClassName]="'comps-export-popover'"
        title="Export"
      >
        <va-icon
          *ngIf="!loadingDocuments; else exportLoading"
          size="small"
          name="file-excel"
          class="va-button-icon"
        ></va-icon>
      </button>
    </div>
  </div>
  <div class="second-action-section display-flex flex-align-center">
    <div *ngIf="isActive" class="comparative-formula-bar">
      <app-subheader-formulabar
        [comparativeAnalysisBorderedFormulaBar]="true"
        [comparativeAnalysisShortFormulaBar]="true"
        [showNewFbar]="false"
      ></app-subheader-formulabar>
    </div>
    <div class="display-flex">
      <app-toggle-checkbox
        [disabled]="
          isMetaInProgress ||
          isDataInProgress ||
          isUserSettingUpdateInProgress ||
          !lineItem
        "
        [checkboxValue]="showBlankRows"
        [label]="showBlankRowsLabel"
        [title]="false"
        labelInfo="Consensus values do not exist for all companies in all time periods."
        (onCheckboxChange)="handleShowBlanksSwitchChange($event)"
        class="ml-12"
      ></app-toggle-checkbox>
    </div>
  </div>

  <div *ngIf="isMetaInProgress" style="height: 600px">
    <div nz-menu>
      <div
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </div>
    </div>
  </div>
  <section
    *ngIf="!isMetaInProgress"
    class="comparative-grid-content-section grid-content"
  >
    <app-comparison-grid
      [gridData]="gridData"
      [isVisible]="isActive"
      [magnitudeMessage]="magnitudeMessage"
      [isDataInProgress]="isDataInProgress"
      [showBlankRows]="showBlankRows"
      [hasFormulaBar]="true"
      [selectedCell]="selectedCell"
      [selectedRow]="selectedRow"
      [sortByColumnId]="gridSortByColumnId"
      [sortByDirection]="
        pageShortName === pageNameData.industrySurprise ? 'asc' : 'desc'
      "
      [shouldShortDataOnChange]="true"
      (handleCellClick)="createDpParam($event)"
      (rowClick)="handleRowClick($event)"
      (updateTickerOrder)="updateTickerOrder($event)"
    ></app-comparison-grid>
    <div *ngIf="isDataInProgress" class="grid-overlay-loader">
      <img
        class="grid-overlay-loader-img"
        alt="Loading"
        [src]="assets + '/spinner-blue.gif'"
        width="64"
        height="64"
      />
    </div>
  </section>
</div>
<ng-template #exportOptionsTemplate>
  <div (click)="exportValue(1)" class="comp-export-opt">Values</div>
  <div (click)="exportValue(0)" class="comp-export-opt">
    Excel Add-In Formulas
  </div>
</ng-template>
<ng-template #exportLoading>
  <div>
    <ng-template #indicatorTemplate>
      <va-icon
        isFontAwesome="true"
        [name]="faSpinner"
        spin="true"
        class="va-button-icon"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </div>
</ng-template>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faCheck"
      class="snack-icon snack-success-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faTimesCircle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faInfoCircle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
